import { Outlet, createFileRoute } from "@tanstack/react-router";

import { m } from "@/paraglide/messages.js";

// Names the "/training/history" step of the breadcrumb on a workout's page.
export const Route = createFileRoute("/(private)/training/history")({
  loader: () => ({ crumb: m.hub_tab_history() }),
  component: Outlet,
});
